<template>
  <div>
    <output-dialog-split
      :confirmed="shipment.confirmed"
      :operation="operation"
      :pages="pages"
      @confirm="confirm"
      @fix="fix"
      @recordHistory="recordHistory"
      @sjlDownload="sjlDownload"
      filename="輸入諸掛（無償）請求書.pdf"
      orientation="portrait"
      ref="printDlg"
      title="輸入諸掛（無償）請求書"
      confirmAuth="SHARP_REQUEST_BOOK_ISSUE_CONFIRM"
    >
      <template slot-scope="{ page }">
        <jpy-page
          :operation="operation"
          :shipment="page"
          v-if="page.type === 'JPY'"
        ></jpy-page>
        <usd-page
          :operation="operation"
          :shipment="page"
          v-if="page.type === 'USD'"
        ></usd-page>
      </template>
    </output-dialog-split>
    <fix-dialog @refresh="refresh" ref="fixDialog" />
  </div>
</template>
<script>
import JpyPage from './JpyPage'
import UsdPage from './UsdPage'
import FixDialog from './FixDialog'

export default {
  components: { JpyPage, UsdPage, FixDialog },
  data() {
    return {
      pages: [],
      operation: null,
      shipment: {},
    }
  },
  methods: {
    popup(data, operation) {
      this.pages = []
      this.operation = operation
      this.shipment = data
      this.load()
    },
    load() {
      this.$http.get(`delivery-orders/do/${this.shipment.id}`).then((res) => {
        this.pages.push({ ...res.data, type: 'JPY' })
        this.pages.push({ ...res.data, type: 'USD' })
        this.shipment = res.data
        this.$refs.printDlg.show = true
      })
    },
    fix() {
      this.$refs.fixDialog.popup(this.shipment)
    },
    refresh() {
      this.pages = []
      this.load()
    },
    confirm() {
      this.$http
        .put(`delivery-orders/${this.shipment.id}/confirmed`)
        .then(() => {
          this.$message('', 'SUCCESS')
          this.refresh()
          this.$emit('reload')
        })
    },
    sjlDownload() {
      this.$http
        .put(`delivery-orders/${this.shipment.id}/sjl-download`)
        .then(() => {
          this.$message('', 'SUCCESS')
          this.refresh()
          this.$emit('reload')
        })
    },
    recordHistory() {
      console.log('record history')
      this.$http
        .post(`invoicing/${this.shipment.id}?type=${this.operation}`)
        .then(() => {
          this.$message('', 'SUCCESS')
          this.$refs.printDlg.show = false
          this.$emit('reload')
        })
        .catch(() => {
          this.$message('', 'FAILED')
        })
    },
  },
}
</script>